export default __webpack_public_path__ + "static/media/ee.d3c81bb7.svg";